<template>

  <div class="container">

    <BreadcrumSection :part1="$t('Activitats')"></BreadcrumSection>

    <h1>{{ $t("Activitats") }}</h1> 

    <MaterialsCommon init-query="tipus:(activitat OR material)" router-name="activitats"></MaterialsCommon>

  </div>

</template>

<script>

import store from "@/store";
import BreadcrumSection from "@/components/sections/BreadcrumbSection.vue";
import {setMetadata} from "@/composables/metadataFunctions";
import MaterialsCommon from "@/components/MaterialsCommon.vue";
import {onActivated, onMounted, ref} from "vue";
import {useRoute} from "vue-router";
import {useI18n} from "vue-i18n";

export default {
  name: "ActivitatsView",
  components: {
    MaterialsCommon,
    BreadcrumSection
  },

  setup(){
    const route = useRoute();
    const { t } = useI18n();
    const isDataLoaded = ref(false);

    onMounted(async () => {
      setMetadata(t('Activitats'))
      await store.dispatch('updateSearchSelected', "Materials");
      await store.dispatch('updateBackgroundImage', { view: route.name, url: require('@/assets/images/sections/banner-brown.webp') });
      isDataLoaded.value = true
    });


    onActivated(() => {
      if (!isDataLoaded.value) {
        // Data loading logic
      }
    });

    return{
    }
  }
}

</script>

<style scoped>
</style>
